import { useState, useEffect, useRef, use, act } from 'react';
import { toast } from 'react-toastify';
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import PlaylistItem from './PlaylistItem';
import DragDrop from './DragDrop';
import { ListPlus, Maximize2, Minimize2, Search, Heart, HeartCrack, ListVideo, HeartMinus } from 'lucide-react';

const PlaylistGallery = ({ dailyList, heartList, playlists, crackList, onResize, setFilespec, refreshPlaylists }) => {
    const { user } = useUser();
    const [maximized, setMaximized] = useState(false);

    const handleMaximized = () => {
        onResize();
        setMaximized(!maximized);
    };

    return (
        <div className={`relative bg-gray-800 rounded-lg mx-4 space-y-2 p-4
            ${maximized
                // ? 'h-186 w-200'
                // : 'h-142 w-96 mt-4'
                ? 'min-h-[calc(66vh)] w-200'
                : 'min-h-[calc(66vh)] w-96 mt-4'
            }
        `}>
            <div className='hidden custom-flex absolute inset-y-0 right-0 z-50'>
                <button
                    onClick={handleMaximized}
                    className="flex w-10 h-10 bg-gray-700 rounded-full items-center justify-center text-orange-400 hover:bg-gray-600 transition-all duration-300 border border-white/20 hover:scale-110"
                >
                    {maximized
                        ? <Minimize2 size={24}/>
                        : <Maximize2 size={24}/>
                    }
                </button>
            </div>
            <div className={`flex-1 items-top justify-center bg-gray-800 rounded-lg w-full
                    ${maximized
                        ? 'h-25'
                        : 'h-17'
                    }
                `}>
                {dailyList?.length > 0
                    ? <PlaylistItem
                        images={dailyList}
                        maximized={maximized}
                        listType={<Search size={24}/>}
                        setFilespec={setFilespec}
                        refreshPlaylists={refreshPlaylists}
                        playlist_id={-2}
                    />
                    : <></>
                }
            </div>
            <div className={`flex-1 items-top justify-center bg-gray-800 rounded-lg w-full
                    ${maximized
                        ? 'h-25'
                        : 'h-17'
                    }
                `}>
                {heartList?.length > 0
                    ? <PlaylistItem
                        images={heartList}
                        maximized={maximized}
                        listType={<Heart size={24}/>}
                        setFilespec={setFilespec}
                        refreshPlaylists={refreshPlaylists}
                        playlist_id={0}
                    />
                    : <></>
                }
            </div>
            <div className={`flex items-top justify-between bg-gray-800 rounded-lg w-full
                    ${maximized
                        ? 'h-20'
                        : 'h-12'
                    }
                `}>
                <div className='flex space-x-1'>
                    <DragDrop
                        icon={ListPlus}
                        maximized={maximized}
                        refreshPlaylists={refreshPlaylists}
                    />
                    <DragDrop
                        icon={HeartMinus}
                        maximized={maximized}
                        refreshPlaylists={refreshPlaylists}
                    />
                </div>
                <DragDrop
                    icon={HeartCrack}
                    maximized={maximized}
                    refreshPlaylists={refreshPlaylists}
                />
            </div>
            <hr className='bg-gray-400 h-0.5'></hr>
            <div className={`flex items-top justify-center bg-gray-800 rounded-lg w-full
                    ${maximized
                        // ? 'h-98'
                        // : 'h-77'
                        // ? 'h-73'
                        // : 'h-60'
                        ? 'min-h-[calc(41vh)]'
                        : 'min-h-[calc(41vh)]'
                    }
                `}>
                <div className={`flex-1 overflow-y-auto overscroll-contain touch-pan-y space-y-2 h-full z-100
                    `}>
                    <div className=''>
                        {playlists?.length > 0
                            ?
                            playlists?.map((playlist) => (
                                <PlaylistItem
                                    key={`playlist${playlist?.id}`}
                                    images={playlist.playloads}
                                    maximized={maximized}
                                    listType={<ListVideo size={24} />}
                                    setFilespec={setFilespec}
                                    refreshPlaylists={refreshPlaylists}
                                    playlist_id={playlist.id}
                                />
                            ))
                            : <></>
                        }
                    </div>
                </div>
            </div>
            <hr className='bg-gray-400 h-0.5'></hr>
            <div className="flex-1 items-top justify-center bg-gray-800 rounded-lg w-full">
                {crackList?.length > 0
                    ? <PlaylistItem
                        images={crackList}
                        maximized={maximized}
                        listType={<HeartCrack size={24} />}
                        setFilespec={setFilespec}
                        refreshPlaylists={refreshPlaylists}
                        playlist_id={-1}
                    />
                    : <></>
                }
            </div>
        </div>
    );
};

export default PlaylistGallery;

